import sha256 from 'crypto-js/sha256';
import base64 from 'crypto-js/enc-base64';
export const base64url = (source) => {
    // Encode in classical base64
    let encodedSource = base64.stringify(source);
    // Remove padding equal characters
    encodedSource = encodedSource.replace(/=+$/, '');
    // Replace characters according to base64url specifications
    encodedSource = encodedSource.replace(/\+/g, '-');
    encodedSource = encodedSource.replace(/\//g, '_');
    return encodedSource;
};
export const generateRandomAlphaNumericString = (L) => {
    function c() {
        return Math.floor(Math.random() * 5) < 1
            ? Math.floor(Math.random() * 10) + 48
            : String.fromCharCode(65 +
                Math.floor(Math.random() * 26) +
                Math.floor(Math.random() * 2) * 32);
    }
    let i;
    let s = '';
    let m = L;
    m = m || Math.floor(Math.random() * 7) + 8;
    for (i = 0; i < m; i += 1) {
        s += c();
    }
    return s;
};
const chosenLength = Math.floor(Math.random() * (128 - 43)) + 43;
export const generateCodeVerifier = () => generateRandomAlphaNumericString(chosenLength);
export const createCodeChallenge = (codeVerifier) => base64url(sha256(codeVerifier));
